export default {
  name: 'Navigation',
  btn: {
    addExternalLink: 'Add External Link',
    addInnerLink: 'Add Internal Link'
  },
  label: {
    link: 'Link:',
    backgroundColor: 'Background Color',
    textColor: 'Font Color',
    activeColor: 'Active Page Color',
    hoverColor: 'Mouseover Color (PC)',
    btnColor: 'Button Color (Mobile)'
  },
  placeholder: {
    linkName: 'Input link Name',
    linkUrl: 'Input link Url',
    selectInnerLink: 'Select internal link',
    selectInnerPage: 'Select internal link'
  },
  openInNewTab: 'Open in new tab'
}
